import './ImageSetBadge.scss';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Option, Select } from '@mui/joy';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ImageSetType } from '../../projectDetails/sub/images/projectDetailsImages.model';

interface ImageSetBadgeProps {
  set: ImageSetType;
  disabled?: boolean;
  onChange: (imageSetType: ImageSetType) => Promise<void>;
}

export const ImageSetBadge = observer(({ set, disabled, onChange }: ImageSetBadgeProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <Select
      value={set}
      onChange={(_, v) => {
        void onChange(v ?? ImageSetType.NotSet);
      }}
      className={classNames('thumb-set-type-dropdown image-set-badge', set.toLowerCase())}
      disabled={disabled}
      indicator={disabled ? null : <FontAwesomeIcon icon={faChevronDown} />}
    >
      {Object.values(ImageSetType).map((o) => (
        <Option
          value={o}
          key={o}
        >
          {t(`image_set_options.${o}`)}
        </Option>
      ))}
    </Select>
  );
});
